import { render, staticRenderFns } from "./ContactDisplayAndEdit.vue?vue&type=template&id=410cdbc9&scoped=true&"
import script from "./ContactDisplayAndEdit.vue?vue&type=script&lang=js&"
export * from "./ContactDisplayAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContactDisplayAndEdit.vue?vue&type=style&index=0&id=410cdbc9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410cdbc9",
  null
  
)

export default component.exports